import React from "react"
import { Modal, Grid, Button } from "semantic-ui-react"
import "./ExternalLink.css"

function ExternalLinkModal({ href, onCancel }) {
  return (
    <Modal
      className="ExternalLinkModal"
      defaultOpen={true}
      closeOnDimmerClick={false}
      closeOnDocumentClick={false}
    >
      <Modal.Content>
        <p>
          You are following a link to another company’s website. SAVVI Financial
          cannot attest to the accuracy of the information provided by the link.
          You will be subject to the destination site's privacy policy.
        </p>
      </Modal.Content>
      <Modal.Actions>
        <Grid>
          <Grid.Row columns="equal">
            <Grid.Column textAlign="left">
              <Button
                content="Cancel"
                color="red"
                basic
                fluid
                onClick={onCancel}
              />
            </Grid.Column>
            <Grid.Column textAlign="right">
              <Button content="Continue" primary fluid href={href} />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Modal.Actions>
    </Modal>
  )
}

export class ExternalLinkButton extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      showConfirm: false
    }
  }
  onCancel = () => {
    this.setState({ showConfirm: false })
  }
  render = () => {
    const { href, children, ...rest } = this.props
    return (
      <span>
        <Button
          type="button"
          className={this.props.className}
          onClick={() => {
            this.setState({ showConfirm: true })
          }}
          {...rest}
        >
          {children}
        </Button>
        {this.state.showConfirm ? (
          <ExternalLinkModal href={href} onCancel={this.onCancel} />
        ) : null}
      </span>
    )
  }
}

export function ExternalLink(props) {
  return <ExternalLinkButton className="ExternalLink__buttonlink" {...props} />
}
